import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const espace = axios.create({ baseURL: API, withCredentials: true });

const Ctx = createContext(null);

export function MemberAuthProvider({ children }) {
  const [member, setMember] = useState(null); // null=loading, false=anon, object=authed
  const refresh = useCallback(async () => {
    try {
      const { data } = await espace.get("/espace/me");
      setMember(data);
    } catch {
      setMember(false);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await espace.post("/espace/login", { email, password });
    setMember(data); return data;
  };
  const register = async (payload) => {
    const { data } = await espace.post("/espace/register", payload);
    setMember(data); return data;
  };
  const logout = async () => {
    try { await espace.post("/espace/logout"); } catch {}
    setMember(false);
  };
  const updateProfile = async (patch) => {
    const { data } = await espace.put("/espace/profile", patch);
    setMember(data); return data;
  };

  return (
    <Ctx.Provider value={{ member, espace, login, register, logout, updateProfile, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export function useMember() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useMember must be used inside MemberAuthProvider");
  return v;
}

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erreur";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  return String(d);
}
